/** CP・ゴールの光の柱と、名前のラベル（docs/05_rendering-and-audio.md 9 章） */
import * as THREE from 'three';
import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import type { NodeData } from '../../core/world';
import { nodeKindColor } from './nodeMarkers';

/** 光の柱の不透明度と、近いカメラで薄くする距離（m）：これより近いと見えない・これより遠いと元の濃さ */
const PILLAR_OPACITY = 0.28;
const FADE_NEAR_M = 250;
const FADE_FAR_M = 1200;

export interface CourseMarkers {
  group: THREE.Group;
  /** カメラが柱に近いほど薄くする（追従カメラで柱の中に入ると画面が覆われるため） */
  update(camera: THREE.Camera): void;
}

export function createCourseMarkers(nodes: NodeData[], courseIds: number[]): CourseMarkers {
  const group = new THREE.Group();
  const pillars: THREE.Mesh<THREE.CylinderGeometry, THREE.MeshBasicMaterial>[] = [];
  const geo = new THREE.CylinderGeometry(140, 140, 3000, 24, 1, true);
  for (const id of courseIds) {
    const node = nodes[id];
    if (!node) continue;
    const color = new THREE.Color(nodeKindColor(node.kind));
    const pillar = new THREE.Mesh(
      geo,
      new THREE.MeshBasicMaterial({
        color,
        transparent: true,
        opacity: PILLAR_OPACITY,
        depthWrite: false,
        side: THREE.DoubleSide,
        blending: THREE.AdditiveBlending,
        fog: false,
      }),
    );
    pillar.position.set(node.pos.x, node.pos.y + 1500, node.pos.z);
    group.add(pillar);
    pillars.push(pillar);

    const el = document.createElement('div');
    el.className = 'world-label world-label--course';
    el.style.setProperty('--label-color', nodeKindColor(node.kind));
    el.textContent = node.name ?? '';
    const label = new CSS2DObject(el);
    label.position.set(node.pos.x, node.pos.y + 3100, node.pos.z);
    group.add(label);
  }
  return {
    group,
    update(camera) {
      for (const p of pillars) {
        const d = Math.hypot(camera.position.x - p.position.x, camera.position.z - p.position.z);
        const k = THREE.MathUtils.smoothstep(d, FADE_NEAR_M, FADE_FAR_M);
        p.material.opacity = PILLAR_OPACITY * k;
        p.visible = k > 0.01;
      }
    },
  };
}

/** 選手のピン（P0 はプレイヤーのみ） */
export function createAthletePin(
  name: string,
  color: string,
): { object: CSS2DObject; setPosition(x: number, y: number, z: number): void } {
  const el = document.createElement('div');
  el.className = 'athlete-pin';
  el.style.setProperty('--pin-color', color);
  el.innerHTML = `<span class="athlete-pin__name"></span><span class="athlete-pin__dot"></span>`;
  (el.querySelector('.athlete-pin__name') as HTMLElement).textContent = name;
  const object = new CSS2DObject(el);
  object.center.set(0.5, 1);
  return {
    object,
    setPosition(x, y, z) {
      object.position.set(x, y + 30, z);
    },
  };
}
